module.exports = __webpack_public_path__ + "static/media/box.2236dcec.png";